import get from 'lodash/get';

export default (object) => (property) => get(object, property);
